<form #contactForm="ngForm" (ngSubmit)="onSubmit(contactForm)">
    <div>
        <label for="name">{{ contentService.content().mainPage.contact.form.name }}</label>
        <input type="text" id="name" name="name" #nameField="ngModel"
            [class.is-invalid]="nameField.invalid && nameField.touched"
            [placeholder]="(nameField.invalid && nameField.touched) ? contentService.content().mainPage.contact.form.name.error : contentService.content().mainPage.contact.form.name.placeholder"
            [(ngModel)]="contactData.name" required>
    </div>

    <div class="input-container">
        <label for="email">{{ contentService.content().mainPage.contact.form.email }}</label>

        <input type="email" id="email" name="email" #emailField="ngModel"
            [class.is-invalid]="emailField.invalid && emailField.touched"
            [class.hide-text]="emailField.invalid && emailField.touched && !emailFocused && contactData.email"
            [placeholder]="(emailField.invalid && emailField.touched) ? contentService.content().mainPage.contact.form.email.errorNoText : contentService.content().mainPage.contact.form.email.placeholder"
            [(ngModel)]="contactData.email" required pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
            (focus)="emailFocused = true" (blur)="emailFocused = false">

        @if (emailField.invalid && emailField.touched && !emailFocused && contactData.email) {
        <span class="error-overlay">
            {{ contentService.content().mainPage.contact.form.email.errorInvalidEmail }}
        </span>
        }
    </div>

    <div>
        <label for="message">{{ contentService.content().mainPage.contact.form.message }}</label>
        <textarea id="message" name="message" #messageField="ngModel"
            [class.is-invalid]="messageField.invalid && messageField.touched"
            [placeholder]="(messageField.invalid && messageField.touched) ? contentService.content().mainPage.contact.form.message.error : contentService.content().mainPage.contact.form.message.placeholder"
            [(ngModel)]="contactData.message" required>
        </textarea>
    </div>

    <div class="privacy-wrapper">
        <div id="privacy-container">
            <input type="checkbox" id="privacy-checkbox" name="privacy-checkbox"
                [(ngModel)]="contactData.privacyAccepted" #privacy="ngModel"
                [class.is-invalid]="privacy.invalid && privacy.touched" required>

            <label id="privacy-container-text" for="privacy-checkbox">
                <span class="custom-checkbox"></span>
                <span class="text-content">
                    {{ contentService.content().mainPage.contact.form.privacy.text1 }}
                    <a href="/privacy-policy">{{
                        contentService.content().mainPage.contact.form.privacy.link }}</a>
                    {{ contentService.content().mainPage.contact.form.privacy.text2 }}
                </span>
            </label>
        </div>

        @if (privacy.invalid && privacy.touched) {
        <div class="privacy-error">
            {{ contentService.content().mainPage.contact.form.privacy.error }}
        </div>
        } @else if (formSended && !contactForm.touched) {
        <div class="form-sended-text">
            {{ contentService.content().mainPage.contact.form.submit.feedback }}
        </div>
        } @else {
        <div style="height: 22px; margin-top: 8px;"></div>
        }
    </div>

    <button class="btn-primary" type="submit" [disabled]="!contactForm.valid">
        {{ contentService.content().mainPage.contact.form.submit.button }}
    </button>
</form>